import React from 'react';
import { PropTypes } from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles, { StyledGenericContainer } from '../styles/GenericSkeleton.style';

import SkeletonLineView from '../../../../../../common/molecules/LoaderSkelton/views/SkeletonLine.view';

function GenericSkeleton({ className }) {
  return (
    <StyledGenericContainer className={`${className} skeleton-container`}>
      <SkeletonLineView className="skeleton-view" />
    </StyledGenericContainer>
  );
}

GenericSkeleton.propTypes = {
  className: PropTypes.string.isRequired,
};

export default withStyles(GenericSkeleton, styles);
export { GenericSkeleton as GenericSkeletonVanilla };
